import { FC } from 'react';
import iconLoading from '../../assets/images/icon_loading_circle.gif';
import commonModalClass from '../../assets/scss/CommonModal.module.scss';
import { CommonModal } from '../CommonModal';

export const LoadingModal: FC<{
  active: boolean;
}> = ({ active }) => {
  return (
    <>
      <CommonModal active={active}>
        <img
          className={commonModalClass.loadingImg}
          src={iconLoading}
          alt=""
        />
        <p className={commonModalClass.loadingText}>変更しています。お待ちください。</p>
      </CommonModal>
    </>
  );
};
